export var ManualEventType;
(function (ManualEventType) {
    ManualEventType["DEPOSIT"] = "manual_deposit";
    ManualEventType["WITHDRAW"] = "manual_withdraw";
})(ManualEventType || (ManualEventType = {}));
//# sourceMappingURL=ManualEventType.js.map